import React from 'react';
import PropTypes from 'prop-types';
import {Header} from '../../Header';
import {MainContent} from './MainContent';
import './style.scss';

export function UVTransilluminator(props) {
  return (
    <div className='uvTransiluminator'>
      <Header label={props.title} />
      <MainContent
        onToggleSwitch={props.onToggleSwitch}
        switchedOn={props.switchedOn}
        component={props.component}
      />
    </div>
  );
}

UVTransilluminator.propTypes = {
  /**
   * Title to display on header
   */
  title: PropTypes.string,
  /**
   * Component to be displayed on the UVTransilluminator Board
   */
  component: PropTypes.element,
  /**
   * Boolean to set if Apparatus Turned ON/OFF
   */
  switchedOn: PropTypes.bool,
  /**
   * Function to invoke wnen switch is toggled
   */
  onToggleSwitch: PropTypes.func,
};

UVTransilluminator.defaultProps = {
  title: 'TRANSILLUMINATOR',
  switchedOn: false,
  onSubmit: console.log,
};
